<template>
	<div class="d-flex flex-column ga-6"><!-- TODO: discuss consistent spacing in components here with mamun and also inside withdrawl methods -->


		<RewardsBanner />

		<RewardsCountrySelect />

		<WithdrawlMethods />


	</div>
</template>



<script setup>

import RewardsBanner from '@/components/Rewards/Rewards-Banner.vue';
import WithdrawlMethods from '@/components/Rewards/Withdrawl-Methods.vue';
import RewardsCountrySelect from '@/components/Rewards/Rewards-Country-Select.vue';

</script>